import { render, staticRenderFns } from "./AamsBaseSealCatalogRegister.vue?vue&type=template&id=21007caa&scoped=true&"
import script from "./AamsBaseSealCatalogRegister.vue?vue&type=script&lang=js&"
export * from "./AamsBaseSealCatalogRegister.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21007caa",
  null
  
)

export default component.exports